<!--WHMAGs导航栏-->

<template>
  <div class="main-layout">
    <!-- Scientific Minimalist Navbar -->
    <nav class="scientific-navbar">
      <div class="nav-container">
        <!-- Brand Section -->
        <div class="nav-brand" @click="front()">
          <img src="@/assets/logo/WHMAGS_logo.png" alt="WHMAGs Logo" class="brand-logo" />
          <div class="brand-text">
            <h1 class="site-title">WHMAGs</h1>
            <span class="site-subtitle">{{ $t('nav.subtitle') }}</span>
          </div>
        </div>

        <!-- Desktop Navigation Menu -->
        <div class="nav-menu">
          <div 
            class="nav-item" 
            :class="{ active: activeMenu === 'home' }"
            @click="front()"
          >
            {{ $t('nav.home') }}
          </div>

          <div class="nav-item dropdown-trigger" :class="{ active: activeMenu.startsWith('dataModule') }">
            {{ $t(dataModuleTitle) }}
            <i class="el-icon-arrow-down"></i>
            <div class="dropdown-menu">
              <div class="dropdown-item" @click="navigate('/front/DataOverview', 'dataModule-1', 'DataOverview')">{{ $t('nav.dataOverview') }}</div>
              <div class="dropdown-item" @click="navigate('/front/DataSampleMetadata', 'dataModule-2', 'SampleMetadata')">{{ $t('nav.sampleMetadata') }}</div>
              <div class="dropdown-item" @click="navigate('/front/DataAssemblyQuality', 'dataModule-3', 'AssemblyQualityMetrics')">{{ $t('nav.assemblyQuality') }}</div>
              <div class="dropdown-item" @click="navigate('/front/DataTaxonomicAnnotation', 'dataModule-4', 'TaxonomicProfile')">{{ $t('nav.taxonomicProfile') }}</div>
            </div>
          </div>

          <div 
            class="nav-item"
            :class="{ active: activeMenu === 'dataplatform' }"
            @click="navigate('/DataPlatform', 'dataplatform')"
          >
            {{ $t('nav.dataMonitoring') }}
          </div>

          <div class="nav-item dropdown-trigger" :class="{ active: activeMenu.startsWith('functionModule') }">
            {{ $t(functionModuleTitle) }}
            <i class="el-icon-arrow-down"></i>
            <div class="dropdown-menu">
              <div class="dropdown-item" @click="navigate('/front/FuncQualityAssessment', 'functionModule-1', 'QualityAssessment')">{{ $t('nav.qualityAssessment') }}</div>
              <div class="dropdown-item" @click="navigate('/front/FuncSpeciesAnnotation', 'functionModule-2', 'SpeciesAnnotation')">{{ $t('nav.speciesAnnotation') }}</div>
              <div class="dropdown-item" @click="navigate('/front/FuncStructuralAnnotation', 'functionModule-3', 'StructuralAnnotation')">{{ $t('nav.structuralAnnotation') }}</div>
              <div class="dropdown-item" @click="navigate('/front/FuncFunctionalAnnotation', 'functionModule-4', 'FunctionalAnnotation')">{{ $t('nav.functionalAnnotation') }}</div>
            </div>
          </div>

          <div class="nav-item" :class="{ active: activeMenu === 'resourceSharing' }" @click="navigate('/front/FuncResourceSharing', 'resourceSharing', 'ResourceSharing')">
            {{ $t('nav.resourceSharing') }}
          </div>

          <div class="nav-item" :class="{ active: activeMenu === 'userManual' }" @click="navigate('/front/UserManual', 'userManual', 'UserManual')">
            {{ $t('nav.userManual') }}
          </div>
          
           <div class="nav-item" :class="{ active: activeMenu === 'contact' }" @click="navigate('/front/Contact', 'contact')">
            {{ $t('nav.contact') }}
          </div>
        </div>
        
        <!-- Search & Language (Right aligned) -->
         <div class="nav-tools">
            <div class="simple-search">
                 <input 
                    v-model="searchQuery" 
                    :placeholder="$t('nav.searchPlaceholder')" 
                    @keyup.enter="performSearch"
                 />
                 <i class="el-icon-search" @click="performSearch"></i>
            </div>
            <el-dropdown class="lang-switch" @command="handleLangCommand" trigger="click" popper-class="scientific-dropdown">
              <span class="el-dropdown-link">
                {{ currentLang === 'en' ? 'EN' : '中文' }} <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="en">English</el-dropdown-item>
                <el-dropdown-item command="zh">中文</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
         </div>
      </div>
    </nav>

    <!-- Content Area -->
    <main class="main-content">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
/**
 * Scientific Minimalist Navigation
 */

// Define constants outside component to avoid reactivity overhead and 'this' context issues
const MODULE_DISPLAY_MAP = {
  'dataModule-1': 'nav.dataOverview',
  'dataModule-2': 'nav.sampleMetadata',
  'dataModule-3': 'nav.assemblyQuality',
  'dataModule-4': 'nav.taxonomicProfile',
  'functionModule-1': 'nav.qualityAssessment',
  'functionModule-2': 'nav.speciesAnnotation',
  'functionModule-3': 'nav.structuralAnnotation',
  'functionModule-4': 'nav.functionalAnnotation'
};

export default {
  name: 'MainNavigation',
  data() {
    return {
      activeMenu: 'home',
      searchQuery: '',
      dataModuleTitle: 'nav.dataModule',
      functionModuleTitle: 'nav.functionModule',
      
      // Route Mapping
      routeMenuMap: {
        'home': 'home',
        'DataOverview': 'dataModule-1',
        'DataSampleMetadata': 'dataModule-2',
        'DataAssemblyQuality': 'dataModule-3',
        'DataTaxonomicAnnotation': 'dataModule-4',
        'DataPlatform': 'dataplatform',
        'QualityAssessment': 'functionModule-1',
        'SpeciesAnnotation': 'functionModule-2',
        'StructuralAnnotation': 'functionModule-3',
        'FunctionalAnnotation': 'functionModule-4',
        'ResourceSharing': 'resourceSharing',
        'UserManual': 'userManual',
        'About': 'about',
        'Contact': 'contact',
        'SpeciesDetail': 'dataModule-1',
        'SpeciesDirectory': 'dataModule-1'
      },
      
      menuTitleMap: {
        'dataModule-1': 'DataOverview',
        'dataModule-2': 'SampleMetadata',
        'dataModule-3': 'AssemblyQualityMetrics',
        'dataModule-4': 'TaxonomicProfile',
        'functionModule-1': 'QualityAssessment',
        'functionModule-2': 'SpeciesAnnotation',
        'functionModule-3': 'StructuralAnnotation',
        'functionModule-4': 'FunctionalAnnotation'
      }
    }
  },

  created() {
    this.updateMenuFromRoute();
  },

  watch: {
    '$route'() {
      this.updateMenuFromRoute();
    }
  },

  methods: {
    updateMenuFromRoute() {
      const routeName = this.$route.name;
      const menuIndex = this.routeMenuMap[routeName];
      
      if (menuIndex) {
        this.activeMenu = menuIndex;
        
        // Update Module Titles using the const directly to avoid reactivity issues
        if (menuIndex.startsWith('dataModule')) {
          const newTitle = MODULE_DISPLAY_MAP[menuIndex];
          this.dataModuleTitle = newTitle || 'nav.dataModule';
        } else {
          this.dataModuleTitle = 'nav.dataModule';
        }

        if (menuIndex.startsWith('functionModule')) {
          const newTitle = MODULE_DISPLAY_MAP[menuIndex];
          this.functionModuleTitle = newTitle || 'nav.functionModule';
        } else {
          this.functionModuleTitle = 'nav.functionModule';
        }
      } else {
        this.activeMenu = 'home';
        this.dataModuleTitle = 'nav.dataModule';
        this.functionModuleTitle = 'nav.functionModule';
      }
    },

    handleLangCommand(command) {
      this.$i18n.locale = command;
      localStorage.setItem('app_language', command);
    },

    navigate(url, index, title = '') {
      this.activeMenu = index;
      if (!url) return;
      if (url === '/DataPlatform') {
        location.href = '/DataPlatform';
      } else {
        this.$router.push(url).catch(() => {});
      }
    },

    performSearch() {
      const query = this.searchQuery.trim().toLowerCase();
      if (!query) {
        this.$message?.warning?.('Please enter keywords');
        return;
      }
      
       const searchMap = [
        { keywords: ['overview', '数据概览'], route: '/front/DataOverview', menu: 'dataModule-1' },
        { keywords: ['sample', '样本'], route: '/front/DataSampleMetadata', menu: 'dataModule-2' },
        { keywords: ['quality', '质量'], route: '/front/FuncQualityAssessment', menu: 'functionModule-1' },
        { keywords: ['species', '物种'], route: '/front/FuncSpeciesAnnotation', menu: 'functionModule-2' },
        { keywords: ['annotation', '注释'], route: '/front/FuncFunctionalAnnotation', menu: 'functionModule-4' },
        { keywords: ['resource', '共享'], route: '/front/FuncResourceSharing', menu: 'resourceSharing' },
        { keywords: ['metagenome', '宏基因组'], route: '/front/DataOverview', menu: 'dataModule-1' }
      ];

      const matchedItem = searchMap.find(item =>
        item.keywords.some(keyword => query.includes(keyword))
      );

      if (matchedItem) {
        this.navigate(matchedItem.route, matchedItem.menu);
      } else {
        this.$message?.info?.(`Search results for: "${this.searchQuery}"`);
        // Ideally navigate to a search result page
      }
    },
    
    front() {
        this.navigate('/front/home', 'home');
    }
  },
  computed: {
    currentLang() {
      return this.$i18n.locale;
    }
  }
}
</script>

<style scoped>
/* Scientific Minimalist Navbar Styles */
.scientific-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: #2c3e50; /* Scientific Dark Blue */
  color: #ffffff;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.nav-container {
  max-width: 1400px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

/* Brand */
.nav-brand {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 12px;
  margin-left: -10px; /* Shift slightly left */
}

.brand-logo {
  height: 40px;
  width: auto;
}

.brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.site-title {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  color: #ffffff;
  letter-spacing: 0.5px;
}

.site-subtitle {
  font-size: 10px;
  color: #bdc3c7;
  font-weight: 300;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* Navigation Menu */
.nav-menu {
  display: flex;
  height: 100%;
  gap: 0;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 0 12px;
  height: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #ecf0f1;
  cursor: pointer;
  transition: background-color 0.3s;
  position: relative;
  white-space: nowrap;
}

.nav-item:hover {
  background-color: #34495e;
  color: #ffffff;
}

.nav-item.active {
  background-color: #34495e;
  border-bottom: 3px solid #3498db;
}

/* Dropdowns */
.dropdown-trigger {
  gap: 5px;
}

.dropdown-menu {
  position: absolute;
  top: 60px;
  left: 0;
  background-color: #34495e;
  min-width: 200px;
  display: none;
  flex-direction: column;
  box-shadow: 0 4px 6px rgba(0,0,0,0.15);
  border-radius: 0 0 4px 4px;
}

.dropdown-trigger:hover .dropdown-menu {
  display: flex;
}

.dropdown-item {
  padding: 12px 20px;
  color: #ecf0f1;
  font-size: 13px;
  transition: background 0.2s;
}

.dropdown-item:hover {
  background-color: #2c3e50;
  color: #3498db;
}

/* Search & Tools */
.nav-tools {
    display: flex;
    align-items: center;
    gap: 20px;
}

.simple-search {
    display: flex;
    align-items: center;
    background: #34495e;
    border-radius: 4px;
    padding: 5px 10px;
    border: 1px solid #465c71;
}

.simple-search input {
    background: transparent;
    border: none;
    color: white;
    font-size: 13px;
    width: 150px;
    outline: none;
}

.simple-search input::placeholder {
    color: #95a5a6;
}

.simple-search i {
    color: #bdc3c7;
    cursor: pointer;
}

.lang-switch {
    font-size: 14px;
    color: #ecf0f1;
    cursor: pointer;
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 10px;
    transition: background-color 0.3s;
    border-radius: 4px;
}

.lang-switch:hover {
    background-color: #34495e;
}

.el-dropdown-link {
    display: flex;
    align-items: center;
    gap: 4px;
    height: 100%;
    width: 100%;
    color: inherit;
}

/* Main Content Adjustment */
.main-content {
  margin-top: 60px; /* Match navbar height */
  min-height: calc(100vh - 60px);
  background-color: #f9f9f9; /* Clean scientific background */
}
</style>

<style>
/* Global styles for dropdowns to override Element UI defaults */
.scientific-dropdown {
  border: none !important;
  background-color: #34495e !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
  padding: 5px 0 !important;
  margin-top: 10px !important;
}

.scientific-dropdown .el-dropdown-menu__item {
  color: #ecf0f1 !important;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
  font-size: 14px !important;
  line-height: 2.5 !important;
  padding: 0 20px !important;
}

.scientific-dropdown .el-dropdown-menu__item:hover,
.scientific-dropdown .el-dropdown-menu__item:focus {
  background-color: #2c3e50 !important;
  color: #3498db !important;
}

.scientific-dropdown .popper__arrow {
  display: none !important; /* Minimalist look */
}
</style>
